import { useLazyGlobalPageSettings } from '~/composables/useLazyGlobalPageSettings';
import { resolveWebappLocaleFromRequest } from '~/utils/resolveWebappLocaleFromRequest';
import { isValidWebAppLocale } from '~/utils/guards/isValidWebAppLocale';

export default defineNuxtPlugin({
  name: 'globalPageSettings',
  enforce: 'pre',
  async setup() {
    const { $locale } = useNuxtApp();

    const {
      globalPageSettings,
      isLoading,
      isHydrated,
      load,
      scheduleLazyLoad
    } = useLazyGlobalPageSettings();

    const contentfulUrl = useState<string>('contentfulUrl');
    const webappLocale = resolveWebappLocaleFromRequest();

    if (isValidWebAppLocale(webappLocale)) {
      await load(webappLocale);
    } else {
      scheduleLazyLoad($locale.value);
    }

    return {
      provide: {
        globalPageSettings,
        globalPageSettingsLoading: isLoading,
        globalPageSettingsHydrated: isHydrated,
        contentfulUrl
      }
    };
  }
});
